import React, { FC } from "react";
import { Dialog, DialogContent } from "@mui/material";

interface IClose {
  width?: number;
  height?: number;
  closeModal: () => void;
  children: React.ReactNode;
  isOpen: boolean;
}

export const Modal: FC<IClose> = ({ width, height, closeModal, isOpen, children }) => (
  <Dialog
    open={isOpen}
    onClose={closeModal}
    PaperProps={{
      sx: { minWidth: width, minHeight: height },
    }}
  >
    <DialogContent>{children}</DialogContent>
  </Dialog>
);
